<template>
  <div>
    <Select
      v-model="user.country"
      data-test-id="CountryPicker__Select"
      isFullWidth
      :label="inputFields.country.label"
      large
      :name="inputFields.country.name"
      :options="countryOptions"
      rules="required"
      @blur="sendInputEnteredEvent(inputFields.country)"
    />
    <TransitionWrapper name="slideVertical">
      <ParagraphBody
        v-show="signupDisabledCountries.indexOf(user.country) !== -1"
        :class="$style.text"
        weight="semibold"
      >
        Due to US sanctions impacting Russia and Belarus,
        we are no longer providing access to customers in Russia and Belarus.
      </ParagraphBody>
    </TransitionWrapper>
    <CountryInformation />
    <TransitionWrapper name="slideVertical">
      <Checkbox
        v-show="optOutCountries.indexOf(user.country) !== -1"
        v-model="optOut"
        :class="$style.checkbox"
        :label="inputFields.doubleOptIn.label"
        :name="inputFields.doubleOptIn.name"
        @blur="sendInputEnteredEvent(inputFields.doubleOptIn)"
      />
    </TransitionWrapper>
  </div>
</template>

<script>
import {
  Checkbox,
  ParagraphBody,
  Select,
  TransitionWrapper,
} from '@jumpcloud/ui-components';
import { mapActions, mapState } from 'vuex';
import CountryInformation from 'client/signup/components/CountryInformation.vue';
import SignupConstants from 'client/util/Constants/SignupConstants';
import countries from 'client/util/Constants/countries';

const { optOutCountries, signupDisabledCountries } = SignupConstants;

export default {
  name: 'CountryPicker',

  components: {
    Checkbox,
    CountryInformation,
    ParagraphBody,
    Select,
    TransitionWrapper,
  },

  data() {
    return {
      optOutCountries,
      signupDisabledCountries,
      inputFields: {
        country: {
          label: 'Where is your company located?',
          name: 'country',
        },
        doubleOptIn: {
          label: 'Check this box if you would like to opt out of receiving marketing communications',
          name: 'doubleOptIn',
        },
      },
    };
  },

  computed: {
    ...mapState(['user']),

    countryOptions() {
      // Informs order of priorityOptions as well
      const priorityCountries = ['United States', 'Canada', 'United Kingdom', 'India'];

      const countryOptions = countries.map(
        country => ({
          name: country.name,
          value: country.name,
        }),
      );

      const priorityOptions = countryOptions.filter(
        country => priorityCountries.includes(country.name),
      );

      const nonPriorityOptions = countryOptions.filter(
        country => !priorityCountries.includes(country.name),
      );

      priorityOptions.sort(
        (a, b) => priorityCountries.indexOf(a.name) - priorityCountries.indexOf(b.name),
      );
      nonPriorityOptions.sort((a, b) => a.name.localeCompare(b.name));

      return priorityOptions.concat(nonPriorityOptions);
    },

    optOut: {
      get() {
        return !this.user.doubleOptIn;
      },

      set(newVal) {
        this.user.doubleOptIn = !newVal;
      },
    },
  },

  methods: {
    ...mapActions([
      'sendInputEnteredEvent',
    ]),
  },
};
</script>

<style module>
.checkbox span {
  font-size: var(--jcBodySmall);
  margin-bottom: var(--jc-spacer-medium);
}

.text {
  color: var(--jc-color-error-strong);
}

</style>
